export default "__VITE_ASSET__d51ecfe3__"